module.exports = __webpack_public_path__ + "static/img/bannerImage1.2fbadf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/config/bannerImage1.png
// module id = HzLD
// module chunks = 0